import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://hellogassy-backend.onrender.com/api';

export interface Zone {
  _id: string;
  name: string;
  price: number;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const zoneService = {
  getAllZones: async (): Promise<Zone[]> => {
    const response = await axios.get(`${API_URL}/zones`, authHeaders());
    return response.data;
  },

  getZone: async (id: string): Promise<Zone> => {
    const response = await axios.get(`${API_URL}/zones/${id}`, authHeaders());
    return response.data;
  },

  createZone: async (zoneData: { name: string; price: number; description?: string }): Promise<Zone> => {
    const response = await axios.post(`${API_URL}/zones`, zoneData, authHeaders());
    return response.data;
  },

  updateZone: async (
    id: string,
    zoneData: { name: string; price: number; description?: string }
  ): Promise<Zone> => {
    const response = await axios.put(`${API_URL}/zones/${id}`, zoneData, authHeaders());
    return response.data;
  },

  deleteZone: async (id: string) => {
    const response = await axios.delete(`${API_URL}/zones/${id}`, authHeaders());
    return response.data;
  }
};
